<template>
  <div class="container batch">
    <div class="row">
      <div class="col-8">
        <label class="form-group margin-bottom">
          <div class="form-group__label">
            Batch ID
          </div>
          <div class="form-group__input-button">
            <input
              class="input"
              type="text"
              v-model="batch.id"
              @change="addBatchId(batch.id)"
            />
            <button
              class="btn btn--turqoise btn--qr"
              @click="openQrScannerPopup('batchId', null)"
            ></button>
          </div>
        </label>

        <div class="batch__expander">
          <v-expansion-panels>
            <v-expansion-panel
              v-for="(chip, index) in batch.chips"
              :key="index"
            >
              <v-expansion-panel-header>
                <p
                  class="mb-0"
                  v-if="batch.chips[index].status === 'INPROGRESS'"
                >
                  <v-badge color="orange" dot>Chip {{ index + 1 }}</v-badge>
                </p>
                <p
                  class="mb-0"
                  v-else-if="batch.chips[index].status === 'PASSED'"
                >
                  <v-badge color="green" dot>Chip {{ index + 1 }}</v-badge>
                </p>
                <p
                  class="mb-0"
                  v-else-if="batch.chips[index].status === 'FAILED'"
                >
                  <v-badge color="red" dot>Chip {{ index + 1 }}</v-badge>
                </p>
                <p class="mb-0" v-else>Chip {{ index + 1 }}</p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <label class="form-group margin-bottom">
                  <div class="form-group__label">Chip ID</div>
                  <div class="form-group__input-button">
                    <input
                      class="input"
                      type="text"
                      v-model="chip.id"
                      @change="addChipId(index, chip.id)"
                    />
                    <button
                      class="btn btn--turqoise btn--qr"
                      @click="openQrScannerPopup('chipId', index)"
                    ></button>
                  </div>
                </label>

                <div v-if="chip.id || chip.status !== 'NEW'">
                  <div
                    class="margin-bottom"
                    v-for="(test, name, index) in tests"
                    :key="index"
                  >
                    <div class="form-group__label">{{ test.label }}</div>
                    <div>
                      <div class="form-group">
                        <input
                          class="input input-file"
                          type="file"
                          :key="'input' + index"
                          @change="uploadFile($event, name, chip.id)"
                          v-if="!chip.tests[name]"
                        />
                      </div>
                      <div v-if="chip.tests[name]" class="batch__file">
                        <div class="batch__file__name">
                          {{
                            chip.tests[name].filePath
                              ? chip.tests[name].filePath.split("/").pop()
                              : ""
                          }}
                        </div>
                        <div
                          v-if="chip.tests[name].status === 'INPROGRESS'"
                          class="batch__file__status batch__file__status--inprogress"
                        >
                          <div
                            class="batch__file__status__message"
                            v-if="chip.tests[name].message"
                          >
                            {{ chip.tests[name].message }}
                          </div>
                        </div>
                        <div
                          v-if="chip.tests[name].status === 'PASSED'"
                          class="batch__file__status batch__file__status--passed"
                        >
                          <div
                            class="batch__file__status__message"
                            v-if="chip.tests[name].message"
                          >
                            {{ chip.tests[name].message }}
                          </div>
                        </div>
                        <div
                          v-if="chip.tests[name].status === 'FAILED'"
                          class="batch__file__status batch__file__status--failed"
                        >
                          <div
                            class="batch__file__status__message"
                            v-if="chip.tests[name].message"
                          >
                            {{ chip.tests[name].message }}
                          </div>
                        </div>
                        <div
                          v-if="chip.tests[name].status === 'ERROR'"
                          class="batch__file__status batch__file__status--error"
                        >
                          <div
                            class="batch__file__status__message"
                            v-if="chip.tests[name].message"
                          >
                            {{ chip.tests[name].message }}
                          </div>
                        </div>
                        <button
                          class="btn btn--blue-dark"
                          @click.prevent="removeFile($event, name, chip.id)"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>

                  <label class="form-group">
                    <div class="form-group__label">Comment</div>
                    <textarea
                      class="input"
                      v-model="chip.comments"
                      v-on:input="addComment($event, chip.id)"
                      rows="4"
                    ></textarea>
                  </label>
                </div>

                <button
                  @click="removeChip(index)"
                  class="btn btn--red margin-top"
                >
                  Remove Chip
                </button>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="margin-top">
          <button class="btn btn--blue-dark" @click="addChip()">
            Add chip
          </button>
        </div>
      </div>
      <div class="col-4">
        <div class="batch__status" v-if="batch.id">
          <div class="batch__status__save" v-if="!saveStatus">
            Autosave is active
          </div>
          <div
            class="batch__status__save batch__status__save--saving"
            v-if="saveStatus === 'saving'"
          >
            Saving
          </div>
          <div
            class="batch__status__save batch__status__save--saved"
            v-if="saveStatus === 'saved'"
          >
            Saved successfully
          </div>

          <div class="batch__status__title">
            Batch <strong>#{{ batch.id }}</strong>
            <div
              v-if="batch.status === 'INPROGRESS'"
              class="badge badge--orange"
            ></div>
            <div
              v-if="batch.status === 'RELEASED'"
              class="badge badge--green"
            ></div>
            <div
              v-if="batch.status === 'REJECTED'"
              class="badge badge--red"
            ></div>
          </div>

          <ul class="batch__status__stats">
            <li>
              <strong>{{ numberOfCompletedChips }}</strong> out of
              <strong>{{ batch.chips.length }}</strong> chips tested
            </li>
            <li>
              <strong>{{ numberOfCompletedTests }}</strong> out of
              <strong>{{ numberOfTests }}</strong> tests completed
            </li>
          </ul>

          <div class="batch__status__finish">
            <a href="/" class="btn btn--block btn--blue-dark"
              >Back to overview</a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="popup" v-if="qrScannerPopup">
      <div class="popup__inner">
        <div class="qr-scanner-popup">
          <div
            id="video"
            class="qr-scanner-popup__video-container"
            v-if="showVideo"
          >
            <div class="video-inner">
              <video id="video-view"></video>
              <div class="qr-placeholder"></div>
            </div>
          </div>
          <div class="qr-scanner-popup__form">
            <input
              class="input"
              v-model="qrScannerValue"
              type="text"
              placeholder="ID"
            />
            <button class="btn btn--turqoise" @click="addQrScannerPopupValue">
              ADD
            </button>
          </div>
          <button
            class="btn btn--turqoise qr-scanner-popup__cancel"
            @click="closeQrScannerPopup"
          >
            X
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import _filter from "lodash/filter";
import _map from "lodash/map";
import _flatMap from "lodash/flatMap";
import _debounce from "lodash/debounce";
import _includes from "lodash/includes";
import _keys from "lodash/keys";
import { BrowserQRCodeReader } from "@zxing/library";

const statuses = {
  // batches
  rejected: "REJECTED",
  released: "RELEASED",

  // batches or tests
  inProgress: "INPROGRESS",
  completed: "COMPLETED",

  // chips or tests
  new: "NEW",
  failed: "FAILED",
  passed: "PASSED",
  error: "ERROR"
};

export default {
  name: "Batch",

  data: () => ({
    saveStatus: undefined,
    qrScannerPopup: false,
    qrScannerValue: undefined,
    qrScannerType: undefined,
    qrScannerIndex: undefined,
    showVideo: false,
    video: undefined,
    batch: {},
    progress: 0,
    tests: {
      "blank-spectrum": {
        label: "Blank Spectrum",
        placeHolder: "Select Blank Spectrum",
        icon: "mdi-blur"
      },
      "reference-spectrum": {
        label: "Reference Spectrum",
        placeHolder: "Select Reference Spectrum",
        icon: "mdi-chart-line"
      }
    },
    batchListener: null
  }),

  async created() {
    if (!this.$route.params.batchId) {
      return false;
    }
    const db = firebase.firestore();

    this.batchListener = db
      .collection("batches")
      .where("id", "==", this.$route.params.batchId)
      .onSnapshot(async snapshot => {
        if (!snapshot.docs.length) {
          console.log("batch not found");
          return false;
        }
        this.batch = {
          docId: snapshot.docs[0].id,
          ...snapshot.docs[0].data()
        };
      });
  },

  async destroyed() {
    if (this.batchListener) {
      this.batchListener();
    }
  },

  computed: {
    numberOfCompletedChips() {
      ////      return _filter(this.batch.chips, chip => {
      ////        return _includes([statuses.failed, statuses.passed], chip.status);
      ////      }).length;
      // for each chip, count number of tests with failed or passed status
      return _flatMap(this.batch.chips, chip => {
        const testsCompleted = _filter(chip.tests, test => {
          return _includes([statuses.failed, statuses.passed], test.status);
        }).length;
        if (testsCompleted === _keys(this.tests).length) {
          return 1;
        } else {
          return 0;
        }
      }).reduce((a, b) => a + b, 0);
    },
    numberOfCompletedTests() {
      return _flatMap(this.batch.chips, chip => {
        return _filter(chip.tests, test => {
          return _includes([statuses.failed, statuses.passed], test.status);
        });
      }).length;
    },
    numberOfTests() {
      return this.batch.chips.length * _keys(this.tests).length;
    }
  },

  methods: {
    async uploadFile(event, type, chipId) {
      let page = this;

      this.setSaveStatus("saving");
      const file = event.target.files[0];
      const fileName =
        type + "." + file.name.substr(file.name.lastIndexOf(".") + 1);

      const db = firebase.firestore();
      const storageRef = firebase.storage().ref();
      const batchRef = db.collection("batches").doc(this.batch.docId);
      const fileRef = storageRef.child(
        `batches/${this.batch.docId}/${chipId}/${fileName}`
      );

      async function onProgress(snap) {
        this.progress = Math.round(
          (snap.bytesTransferred / snap.totalBytes) * 100
        );
      }
      async function onError(err) {
        console.log(err);
      }

      async function onComplete() {
        try {
          await db.runTransaction(async transaction => {
            const doc = await transaction.get(batchRef);
            const chips = _map(doc.data().chips, chip => {
              if (chip.id !== chipId) {
                return chip;
              }

              if (!chip.tests[type]) {
                chip.tests[type] = {};
              }
              chip.status = statuses.inProgress;
              chip.tests[type].status = statuses.inProgress;
              chip.tests[type].filePath = fileRef.fullPath;
              return chip;
            });
            await transaction.update(batchRef, { chips });
            page.setSaveStatus("saved");
          });
        } catch (err) {
          console.log(err);
        }
      }

      const metadata = {
        customMetadata: {
          type,
          chipId,
          batchId: this.batch.id,
          docId: this.batch.docId
        }
      };
      const task = fileRef.put(file, metadata);
      task.on("state_changed", onProgress, onError, onComplete);
    },

    async removeFile(files, type, chipId) {
      // TODO: actually remove file from storage
      if (confirm("Are you sure?") !== true) {
        return false;
      }

      this.setSaveStatus("saving");

      const db = firebase.firestore();
      const batchRef = db.collection("batches").doc(this.batch.docId);

      try {
        await db.runTransaction(async transaction => {
          const doc = await transaction.get(batchRef);
          const chips = _map(doc.data().chips, chip => {
            if (chip.id !== chipId) {
              return chip;
            }

            delete chip.tests[type];
            chip.status = statuses.inProgress;

            return chip;
          });

          await transaction.update(batchRef, {
            chips,
            status: statuses.inProgress
          });
        });

        this.setSaveStatus("saved");
      } catch (err) {
        console.log(err);
      }
    },

    async addChipId(index, chipId) {
      this.setSaveStatus("saving");
      const db = firebase.firestore();

      // check whether files have been uploaded for this chip
      // if so, ensure that chip ID stays populated
      if (_keys(this.batch.chips[index].tests).length > 0 && !chipId) {
        console.log(
          "Empty chip ID field not allowed for chip with completed tests"
        );
        chipId = `chip ${index + 1}`;
      } else if (!chipId) {
        this.batch.chips[index].status = "NEW";
        chipId = "";
      }

      // update chip metadata
      try {
        this.batch.chips[index].id = chipId;
        this.batch.status = statuses.inProgress;
        await db
          .collection("batches")
          .doc(this.batch.docId)
          .set(this.batch);
        this.setSaveStatus("saved");
      } catch (err) {
        console.log(err);
      }
    },

    async addBatchId(batchId) {
      this.setSaveStatus("saving");
      this.batch.id = batchId;
      const db = firebase.firestore();
      if (!batchId) {
        return false;
      }

      try {
        const snapshot = await db
          .collection("batches")
          .where("batchId", "==", batchId)
          .get();
        if (snapshot.docs.length) {
          console.log("batch already exists");
          return false;
        }
        await db
          .collection("batches")
          .doc(this.batch.docId)
          .update({ id: batchId });
        this.$router.push({ name: "Batch", params: { batchId } });
        this.setSaveStatus("saved");
      } catch (err) {
        console.log(err);
      }
    },

    async addQrScannerPopupValue() {
      if (this.qrScannerValue) {
        if (this.qrScannerType === "batchId") {
          this.addBatchId(this.qrScannerValue);
        } else if (this.qrScannerType === "chipId") {
          this.addChipId(this.qrScannerIndex, this.qrScannerValue);
        }
      }

      this.closeQrScannerPopup();
    },

    async openQrScannerPopup(type, index) {
      this.qrScannerPopup = true;
      const codeReader = new BrowserQRCodeReader();
      this.showVideo = true;
      this.video = codeReader;
      this.qrScannerType = type;
      this.qrScannerIndex = index;

      try {
        const result = await codeReader.decodeOnceFromVideoDevice(
          undefined,
          "video-view"
        );
        this.show = false;

        if (result.text) {
          this.qrScannerValue = result.text;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async closeQrScannerPopup() {
      this.qrScannerValue = undefined;
      this.qrScannerType = undefined;
      this.qrScannerIndex = undefined;
      this.qrScannerPopup = false;
      this.video.reset();
      this.showVideo = false;
    },

    async setSaveStatus(status) {
      this.saveStatus = status;
    },

    async addChip() {
      this.batch.chips.push({
        id: "",
        comments: "",
        status: "NEW",
        tests: {}
      });

      this.saveBatch();
    },

    async removeChip(index) {
      if (window.confirm("Are you sure?")) {
        this.batch.chips.splice(index, 1);
        this.saveBatch();
      }
    },

    async saveBatch() {
      this.setSaveStatus("saving");
      const db = firebase.firestore();

      try {
        await db
          .collection("batches")
          .doc(this.batch.docId)
          .set(this.batch);
        this.setSaveStatus("saved");
      } catch (err) {
        console.log(err);
      }
    },

    addComment: _debounce(async function(event, chipId) {
      let page = this;
      page.setSaveStatus("saving");
      const value = event.target.value;
      const db = firebase.firestore();
      const batchRef = db.collection("batches").doc(this.batch.docId);

      try {
        await db.runTransaction(async transaction => {
          const doc = await transaction.get(batchRef);
          const chips = _map(doc.data().chips, chip => {
            if (chip.id !== chipId) {
              return chip;
            }
            return { ...chip, comments: value };
          });

          await transaction.update(batchRef, { chips });
        });
        page.setSaveStatus("saved");
      } catch (err) {
        console.log(err);
      }
    }, 500)
  }
};
</script>

<!--
<v-dialog v-model="dialog_error" width="500">
  <v-alert border="right" colored-border type="error" class="mb-0">
    <p>
      Fusce commodo aliquam arcu. Pellentesque posuere. Phasellus tempus.
      Donec posuere vulputate arcu.
    </p>

    <v-btn color="error" depressed @click="dialog_error = false">
      Ok
    </v-btn>
  </v-alert>
</v-dialog>

<v-dialog v-model="dialog_warning" width="500">
  <v-alert border="right" colored-border type="warning" class="mb-0">
    <p>
      Fusce commodo aliquam arcu. Pellentesque posuere. Phasellus tempus.
      Donec posuere vulputate arcu.
    </p>

    <v-btn color="warning" depressed @click="dialog_warning = false">
      Ok, I understand
    </v-btn>
  </v-alert>
</v-dialog>

-->
